
import axios from "./themeInstance"
import { toast } from "react-toastify"
export default async (theme:any) => {
  const payload ={
    "title":theme.title,
    "theme":theme.theme
  };

  try {
    const response: any = await axios.post(`/themes`, payload);
    return response.data
  } catch (error) {
    return null
  }
}
